import 'core-js/fn/object/entries';
import 'core-js/fn/array/flatten';
import shuffle from 'shuffle-array';
import chunk from 'lodash.chunk';
import allKana from '@/kana.json';

const getKana = character => {
  if(character && character.seion) {
    return {
      hiragana: character.seion.hiragana,
      katakana: character.seion.katakana,
      romaji: character.seion.romaji,
      selected: false,
      wrong: false
    };
  }

  return {
    selected: false
  };
};

function getOrderedKana() {
  const kana = Object.entries(allKana);
  const { n } = allKana['*'];

  kana.pop();

  return kana.map(([k, v]) => {
    const { a, i, u, e, o } = v;

    if(k === 'w') {
      return [a, null, o, null, n].map(getKana);
    }

    return [a, i, u, e, o]
      .map(getKana);
  });
}

function randomizedKana() {
  const kana = Object.entries(allKana);
  const { n } = allKana['*'];

  const randomized = shuffle(kana.map(([k, v]) => {
    const { a, i, u, e, o } = v;

    if(k === '*') {
      return [n].map(getKana);
    }

    return shuffle([a, i, u, e, o].map(getKana));
  }).flatten().filter(s => s && s.romaji));

  return chunk(randomized, 7);
}

export default {
  getOrderedKana,
  randomizedKana
};



// WEBPACK FOOTER //
// ./src/kana-util.js